import {
    faDotCircle,
    faBars,
} from '@fortawesome/free-solid-svg-icons'

const sidebarMenuList = [
    {
        icon: faBars, label: 'Tasks', key: 'layout', subMenu: [
            { icon: faDotCircle, label: 'Task', link: '/admin/item', key: 'cms-task' },
            { icon: faDotCircle, label: 'Out Of Stock', link: '/admin/outofstock', key: 'outofstock' },
            { icon: faDotCircle, label: 'Out Of Stock Recipient', link: '/admin/outofstockrecipient', key: 'outofstockrecipient' },
        ]
    },
    // {
    //     icon: faBars, label: 'Amenity', key: 'layout', subMenu: [
    //         { icon: faDotCircle, label: 'Room Type', link: '/admin/room-type', key: 'room-type' },
    //         { icon: faDotCircle, label: 'Room Setup', link: '/admin/room-setup', key: 'room-setup' },
    //         { icon: faDotCircle, label: 'Item Room Type', link: '/admin/item-room-type', key: 'item-room-type' }
    //     ]
    // },
    {
        icon: faBars, label: 'In Room Dining', key: 'layout', subMenu: [
            { icon: faDotCircle, label: 'Additional Item', link: '/admin/fnb-additional-item', key: 'fnb-additional-item' },
            { icon: faDotCircle, label: 'Recommendation', link: '/admin/recommendation', key: 'recommendation' },
            { icon: faDotCircle, label: 'Offers', link: '/admin/fnboffer', key: 'specialoffers' },
            { icon: faDotCircle, label: 'Payment Type', link: '/admin/cms-payment-type', key: 'cms-payment-type' }
        ]
    },
    // {
    //     icon: faBars, label: 'Shopping', key: 'layout', subMenu: [
    //         { icon: faDotCircle, label: 'Offers', link: '/admin/retailoffer', key: 'retailoffers' },
    //     ]
    // },
    // {
    //     icon: faBars, label: 'Devarana Wellness', key: 'layout', subMenu: [
    //         { icon: faDotCircle, label: 'Devarana Wellness', link: '/admin/devarana', key: 'devaranas' },
    //         { icon: faDotCircle, label: 'Offers', link: '/admin/spaoffer', key: 'spaoffers' },
    //     ]
    // },
    // {
    //     icon: faBars, label: 'Laundry', key: 'layout', subMenu: [
    //         { icon: faDotCircle, label: 'Choice of Delivery', link: '/admin/laundry-delivery', key: 'laundry-delivery' },
    //         { icon: faDotCircle, label: 'Service', link: '/admin/laundry-service', key: 'laundry-service' },
    //     ]
    // },
    // {
    //     icon: faBars, label: 'Transportation', key: 'layout', subMenu: [
    //         { icon: faDotCircle, label: 'Transportation Type', link: '/admin/cms-transportation-type', key: 'cms-transportation-type' },
    //         { icon: faDotCircle, label: 'Payment Type', link: '/admin/cms-payment-type', key: 'cms-payment-type' }
    //     ]
    // },
    // {
    //     icon: faBars, label: 'Facility Booking', key: 'layout', subMenu: [
    //         { icon: faDotCircle, label: 'Booking Category', link: '/admin/booking-category', key: 'booking-category' },
    //         { icon: faDotCircle, label: 'Booking Sub Category', link: '/admin/booking-sub-category', key: 'booking-sub-category' },
    //         { icon: faDotCircle, label: 'Booking Item', link: '/admin/booking-item', key: 'booking-item' },
    //         { icon: faDotCircle, label: 'Booking Transaction', link: '/admin/booking-transaction', key: 'booking-transaction' }
    //     ]
    // },
    // {
    //     icon: faBars, label: 'Static Menu', key: 'layout', subMenu: [
    //         { icon: faDotCircle, label: 'Daily Activities', link: '/admin/daily-act', key: 'dailyAct' },
    //         { icon: faDotCircle, label: 'Dive Centers', link: '/admin/dive-center', key: 'diveCenter' },
    //     ]
    // },
    {
        icon: faBars, label: 'Transactions', key: 'layout', subMenu: [
            { icon: faDotCircle, label: 'History', link: '/admin/payment-history', key: 'payment-history' },
        ]
    },
    {
        icon: faBars, label: 'Others', key: 'layout', subMenu: [
            { icon: faDotCircle, label: 'Hotel Offers', link: '/admin/eventhotel', key: 'events' },
            { icon: faDotCircle, label: 'Hotel Facilities', link: '/admin/hotelfacility', key: 'facilities' },
            // { icon: faDotCircle, label: 'Dinings', link: '/admin/dining', key: 'dinings' },
            // { icon: faDotCircle, label: 'Experiences', link: '/admin/experience', key: 'experiences' },
            { icon: faDotCircle, label: 'Popups', link: '/admin/popup', key: 'popups' },
            // { icon: faDotCircle, label: 'Hotel Description', link: '/admin/hoteldescription', key: 'hoteldescription' },
            { icon: faDotCircle, label: 'Compendiums', link: '/admin/compendium', key: 'sidebars' },
            { icon: faDotCircle, label: 'Audit Logs', link: '/admin/audit-log', key: 'audit-log' }
        ]
    }
];

const superAdminMenuList = [
    {
        icon: faBars, label: 'Tasks', key: 'layout', subMenu: [
            { icon: faDotCircle, label: 'Task', link: '/admin/item', key: 'cms-task' },
            { icon: faDotCircle, label: 'Out Of Stock', link: '/admin/outofstock', key: 'outofstock' },
            { icon: faDotCircle, label: 'Out Of Stock Recipient', link: '/admin/outofstockrecipient', key: 'outofstockrecipient' },
        ]
    },
    // {
    //     icon: faBars, label: 'Amenity', key: 'layout', subMenu: [
    //         { icon: faDotCircle, label: 'Room Type', link: '/admin/room-type', key: 'room-type' },
    //         { icon: faDotCircle, label: 'Room Setup', link: '/admin/room-setup', key: 'room-setup' },
    //         { icon: faDotCircle, label: 'Item Room Type', link: '/admin/item-room-type', key: 'item-room-type' }
    //     ]
    // },
    {
        icon: faBars, label: 'In Room Dining', key: 'layout', subMenu: [
            { icon: faDotCircle, label: 'Additional Item', link: '/admin/fnb-additional-item', key: 'fnb-additional-item' },
            { icon: faDotCircle, label: 'Recommendation', link: '/admin/recommendation', key: 'recommendation' },
            { icon: faDotCircle, label: 'Offers', link: '/admin/fnboffer', key: 'specialoffers' },
            { icon: faDotCircle, label: 'Payment Type', link: '/admin/cms-payment-type', key: 'cms-payment-type' }
        ]
    },
    // {
    //     icon: faBars, label: 'Shopping', key: 'layout', subMenu: [
    //         { icon: faDotCircle, label: 'Offers', link: '/admin/retailoffer', key: 'retailoffers' },
    //     ]
    // },
    // {
    //     icon: faBars, label: 'Devarana Wellness', key: 'layout', subMenu: [
    //         { icon: faDotCircle, label: 'Devarana Wellness', link: '/admin/devarana', key: 'devaranas' },
    //         { icon: faDotCircle, label: 'Offers', link: '/admin/spaoffer', key: 'spaoffers' },
    //     ]
    // },
    // {
    //     icon: faBars, label: 'Laundry', key: 'layout', subMenu: [
    //         { icon: faDotCircle, label: 'Choice of Delivery', link: '/admin/laundry-delivery', key: 'laundry-delivery' },
    //         { icon: faDotCircle, label: 'Service', link: '/admin/laundry-service', key: 'laundry-service' },
    //     ]
    // },
    // {
    //     icon: faBars, label: 'Transportation', key: 'layout', subMenu: [
    //         { icon: faDotCircle, label: 'Transportation Type', link: '/admin/cms-transportation-type', key: 'cms-transportation-type' },
    //     ]
    // },
    // {
    //     icon: faBars, label: 'Facility Booking', key: 'layout', subMenu: [
    //         { icon: faDotCircle, label: 'Booking Category', link: '/admin/booking-category', key: 'booking-category' },
    //         { icon: faDotCircle, label: 'Booking Sub Category', link: '/admin/booking-sub-category', key: 'booking-sub-category' },
    //         { icon: faDotCircle, label: 'Booking Item', link: '/admin/booking-item', key: 'booking-item' },
    //         { icon: faDotCircle, label: 'Booking Transaction', link: '/admin/booking-transaction', key: 'booking-transaction' }
    //     ]
    // },
    // {
    //     icon: faBars, label: 'Static Menu', key: 'layout', subMenu: [
    //         { icon: faDotCircle, label: 'Daily Activities', link: '/admin/daily-act', key: 'dailyAct' },
    //         { icon: faDotCircle, label: 'Dive Centers', link: '/admin/dive-center', key: 'diveCenter' },
    //     ]
    // },
    {
        icon: faBars, label: 'Transactions', key: 'layout', subMenu: [
            { icon: faDotCircle, label: 'History', link: '/admin/payment-history', key: 'payment-history' },
        ]
    },
    {
        icon: faBars, label: 'Others', key: 'layout', subMenu: [
            { icon: faDotCircle, label: 'Hotel Offers', link: '/admin/eventhotel', key: 'events' },
            { icon: faDotCircle, label: 'Hotel Facilities', link: '/admin/hotelfacility', key: 'facilities' },
            // { icon: faDotCircle, label: 'Dinings', link: '/admin/dining', key: 'dinings' },
            // { icon: faDotCircle, label: 'Experiences', link: '/admin/experience', key: 'experiences' },
            { icon: faDotCircle, label: 'Popups', link: '/admin/popup', key: 'popups' },
            // { icon: faDotCircle, label: 'Hotel Description', link: '/admin/hoteldescription', key: 'hoteldescription' },
            { icon: faDotCircle, label: 'Compendiums', link: '/admin/compendium', key: 'sidebars' },
            { icon: faDotCircle, label: 'Audit Logs', link: '/admin/audit-log', key: 'audit-log' },
            { icon: faDotCircle, label: 'Guest Login Log', link: '/admin/guest-login-log', key: 'guestloginlog' },
        ]
    },
    {
        icon: faBars, label: 'Customization', key: 'layout', subMenu: [
            { icon: faDotCircle, label: 'Template', link: '/admin/template', key: 'template' },
            { icon: faDotCircle, label: 'Language', link: '/admin/cms-language', key: 'cms-language' },
            { icon: faDotCircle, label: 'Web Setting', link: '/admin/web-setting', key: 'web-setting' },
            { icon: faDotCircle, label: 'Menu', link: '/admin/cms-menu', key: 'cms-menu' },
            { icon: faDotCircle, label: 'Items Import/Export', link: '/admin/import-items', key: 'importitems' }
        ]
    }
]

export {
    sidebarMenuList,
    superAdminMenuList
}
